var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "lite-task" },
    [
      _c("div", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.loadingAllTask,
            expression: "loadingAllTask"
          }
        ],
        staticClass: "lite-tasks-loading"
      }),
      _vm._v(" "),
      _vm.$store.state.tasks.length == 0 && !_vm.loadingAllTask
        ? _c("div", { staticClass: "task-none" }, [
            _c("img", {
              attrs: {
                src: require("../../assets/images/task-icon/no_task_bg.png"),
                draggable: "false"
              }
            }),
            _vm._v(" "),
            _c("div", { staticClass: "task-none-title" }, [
              _vm._v(_vm._s(_vm.$t("language.taskList.noTasks")))
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "task-none-desc" }, [
              _vm._v(_vm._s(_vm.$t("language.taskList.noTasksTip")))
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "task-none-btn" }, [
              _c("button", { on: { click: _vm.startCloudTransfer } }, [
                _vm._v(_vm._s(_vm.$t("language.taskList.startCloudTransfer")))
              ]),
              _vm._v(" "),
              _c("button", { on: { click: _vm.startCloudSync } }, [
                _vm._v(_vm._s(_vm.$t("language.taskList.startCloudSync")))
              ])
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.$store.state.tasks.length > 0
        ? _c("div", { staticClass: "task-nav" }, [
            _c("div", { staticClass: "task-tabs" }, [
              _c(
                "div",
                {
                  class:
                    "task-tab" + (_vm.activeName == "all" ? " select" : ""),
                  on: {
                    click: function($event) {
                      return _vm.selectTab("all")
                    }
                  }
                },
                [
                  _c(
                    "el-badge",
                    {
                      staticClass: "lite_task_add_count",
                      attrs: { value: 0, max: 99, hidden: true }
                    },
                    [
                      _c("span", [
                        _vm._v(
                          _vm._s(_vm.$t("language.filters.taskList.type.all"))
                        )
                      ])
                    ]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _vm.copyTaskCount
                ? _c(
                    "div",
                    {
                      class:
                        "task-tab" +
                        (_vm.activeName == "copy" ? " select" : ""),
                      on: {
                        click: function($event) {
                          return _vm.selectTab("copy")
                        }
                      }
                    },
                    [
                      _c(
                        "el-badge",
                        {
                          staticClass: "lite_task_add_count",
                          attrs: {
                            value: _vm.$store.state.liteFileTaskCountCopy,
                            max: 99,
                            hidden: _vm.$store.state.liteFileTaskCountCopy < 1
                          }
                        },
                        [
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm.$t("language.filters.taskList.type.copy")
                              )
                            )
                          ])
                        ]
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.tranTaskCount
                ? _c(
                    "div",
                    {
                      class:
                        "task-tab" +
                        (_vm.activeName == "tran" ? " select" : ""),
                      on: {
                        click: function($event) {
                          return _vm.selectTab("tran")
                        }
                      }
                    },
                    [
                      _c(
                        "el-badge",
                        {
                          staticClass: "lite_task_add_count",
                          attrs: {
                            value: _vm.$store.state.liteFileTaskCountTran,
                            max: 99,
                            hidden: _vm.$store.state.liteFileTaskCountTran < 1
                          }
                        },
                        [
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm.$t(
                                  "language.filters.taskList.type.transfer"
                                )
                              )
                            )
                          ])
                        ]
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.syncTaskCount
                ? _c(
                    "div",
                    {
                      class:
                        "task-tab" +
                        (_vm.activeName == "sync" ? " select" : ""),
                      on: {
                        click: function($event) {
                          return _vm.selectTab("sync")
                        }
                      }
                    },
                    [
                      _c(
                        "el-badge",
                        {
                          staticClass: "lite_task_add_count",
                          attrs: {
                            value: _vm.$store.state.liteFileTaskCountSync,
                            max: 99,
                            hidden: _vm.$store.state.liteFileTaskCountSync < 1
                          }
                        },
                        [
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm.$t("language.filters.taskList.type.sync")
                              )
                            )
                          ])
                        ]
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.backupTaskCount
                ? _c(
                    "div",
                    {
                      class:
                        "task-tab" +
                        (_vm.activeName == "backup" ? " select" : ""),
                      on: {
                        click: function($event) {
                          return _vm.selectTab("backup")
                        }
                      }
                    },
                    [
                      _c(
                        "el-badge",
                        {
                          staticClass: "lite_task_add_count",
                          attrs: {
                            value: _vm.$store.state.liteFileTaskCountBackup,
                            max: 99,
                            hidden: _vm.$store.state.liteFileTaskCountBackup < 1
                          }
                        },
                        [
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm.$t("language.filters.taskList.type.backup")
                              )
                            )
                          ])
                        ]
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.restoreTaskCount
                ? _c(
                    "div",
                    {
                      class:
                        "task-tab" +
                        (_vm.activeName == "restore" ? " select" : ""),
                      on: {
                        click: function($event) {
                          return _vm.selectTab("restore")
                        }
                      }
                    },
                    [
                      _c(
                        "el-badge",
                        {
                          staticClass: "lite_task_add_count",
                          attrs: {
                            value: _vm.$store.state.liteFileTaskCountRestore,
                            max: 99,
                            hidden:
                              _vm.$store.state.liteFileTaskCountRestore < 1
                          }
                        },
                        [
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm.$t("language.filters.taskList.type.restore")
                              )
                            )
                          ])
                        ]
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.websiteTaskCount
                ? _c(
                    "div",
                    {
                      class:
                        "task-tab" +
                        (_vm.activeName == "website" ? " select" : ""),
                      on: {
                        click: function($event) {
                          return _vm.selectTab("website")
                        }
                      }
                    },
                    [
                      _c(
                        "el-badge",
                        {
                          staticClass: "lite_task_add_count",
                          attrs: {
                            value: _vm.$store.state.liteFileTaskCountWebsite,
                            max: 99,
                            hidden:
                              _vm.$store.state.liteFileTaskCountWebsite < 1
                          }
                        },
                        [
                          _c("span", [
                            _vm._v(
                              _vm._s(_vm.$t("language.leftBanner.liteWebsite"))
                            )
                          ])
                        ]
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.cloneTaskCount
                ? _c(
                    "div",
                    {
                      class:
                        "task-tab" +
                        (_vm.activeName == "clone" ? " select" : ""),
                      on: {
                        click: function($event) {
                          return _vm.selectTab("clone")
                        }
                      }
                    },
                    [
                      _c(
                        "el-badge",
                        {
                          staticClass: "lite_task_add_count",
                          attrs: {
                            value: _vm.$store.state.liteFileTaskCountClone,
                            max: 99,
                            hidden: _vm.$store.state.liteFileTaskCountClone < 1
                          }
                        },
                        [
                          _c("span", [
                            _vm._v(
                              _vm._s(_vm.$t("language.leftBanner.liteClone"))
                            )
                          ])
                        ]
                      )
                    ],
                    1
                  )
                : _vm._e()
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "task-nav-right" },
              [
                _vm.activeView == "list" && _vm.multipleSelection.length > 0
                  ? _c("div", {
                      staticClass: "delete-select-tasks",
                      on: {
                        click: function($event) {
                          return _vm.deleteTasks()
                        }
                      }
                    })
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "el-tooltip",
                  { attrs: { effect: "light", placement: "bottom" } },
                  [
                    _c("template", { slot: "content" }, [
                      _c(
                        "div",
                        [
                          _c(
                            "el-checkbox",
                            {
                              model: {
                                value: _vm.taskStatusAll,
                                callback: function($$v) {
                                  _vm.taskStatusAll = $$v
                                },
                                expression: "taskStatusAll"
                              }
                            },
                            [
                              _c("span", { staticClass: "filter-status" }, [
                                _vm._v(
                                  _vm._s(_vm.$t("language.common.selectAll"))
                                )
                              ])
                            ]
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "filter-status-space" }),
                      _vm._v(" "),
                      _c(
                        "div",
                        [
                          _c(
                            "el-checkbox",
                            {
                              model: {
                                value: _vm.taskStatus.create,
                                callback: function($$v) {
                                  _vm.$set(_vm.taskStatus, "create", $$v)
                                },
                                expression: "taskStatus.create"
                              }
                            },
                            [
                              _c("span", { staticClass: "filter-status" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t("language.popup.createTaskStatus")
                                  )
                                )
                              ])
                            ]
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        [
                          _c(
                            "el-checkbox",
                            {
                              model: {
                                value: _vm.taskStatus.pending,
                                callback: function($$v) {
                                  _vm.$set(_vm.taskStatus, "pending", $$v)
                                },
                                expression: "taskStatus.pending"
                              }
                            },
                            [
                              _c("span", { staticClass: "filter-status" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t("language.popup.pendingTaskStatus")
                                  )
                                )
                              ])
                            ]
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        [
                          _c(
                            "el-checkbox",
                            {
                              model: {
                                value: _vm.taskStatus.running,
                                callback: function($$v) {
                                  _vm.$set(_vm.taskStatus, "running", $$v)
                                },
                                expression: "taskStatus.running"
                              }
                            },
                            [
                              _c("span", { staticClass: "filter-status" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t("language.popup.runningTaskStatus")
                                  )
                                )
                              ])
                            ]
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        [
                          _c(
                            "el-checkbox",
                            {
                              model: {
                                value: _vm.taskStatus.cancelled,
                                callback: function($$v) {
                                  _vm.$set(_vm.taskStatus, "cancelled", $$v)
                                },
                                expression: "taskStatus.cancelled"
                              }
                            },
                            [
                              _c("span", { staticClass: "filter-status" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t("language.popup.cancelledTaskStatus")
                                  )
                                )
                              ])
                            ]
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        [
                          _c(
                            "el-checkbox",
                            {
                              model: {
                                value: _vm.taskStatus.completed,
                                callback: function($$v) {
                                  _vm.$set(_vm.taskStatus, "completed", $$v)
                                },
                                expression: "taskStatus.completed"
                              }
                            },
                            [
                              _c("span", { staticClass: "filter-status" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t("language.popup.completedTaskStatus")
                                  )
                                )
                              ])
                            ]
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        [
                          _c(
                            "el-checkbox",
                            {
                              model: {
                                value: _vm.taskStatus.failed,
                                callback: function($$v) {
                                  _vm.$set(_vm.taskStatus, "failed", $$v)
                                },
                                expression: "taskStatus.failed"
                              }
                            },
                            [
                              _c("span", { staticClass: "filter-status" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t("language.popup.failedTaskStatus")
                                  )
                                )
                              ])
                            ]
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        [
                          _c(
                            "el-checkbox",
                            {
                              model: {
                                value: _vm.taskStatus.warn,
                                callback: function($$v) {
                                  _vm.$set(_vm.taskStatus, "warn", $$v)
                                },
                                expression: "taskStatus.warn"
                              }
                            },
                            [
                              _c("span", { staticClass: "filter-status" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t("language.popup.warnTaskStatus")
                                  )
                                )
                              ])
                            ]
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        [
                          _c(
                            "el-checkbox",
                            {
                              model: {
                                value: _vm.taskStatus.error,
                                callback: function($$v) {
                                  _vm.$set(_vm.taskStatus, "error", $$v)
                                },
                                expression: "taskStatus.error"
                              }
                            },
                            [
                              _c("span", { staticClass: "filter-status" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t("language.popup.errorTaskStatus")
                                  )
                                )
                              ])
                            ]
                          )
                        ],
                        1
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "task-filter-status" }, [
                      _vm._v(_vm._s(_vm.$t("language.common.status")))
                    ])
                  ],
                  2
                ),
                _vm._v(" "),
                _c("div", { staticClass: "task-nav-view" }, [
                  _c("div", {
                    class:
                      "task-nav-box" +
                      (_vm.activeView == "box" ? " select" : ""),
                    on: {
                      click: function($event) {
                        return _vm.selectView("box")
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c("div", {
                    class:
                      "task-nav-list" +
                      (_vm.activeView == "list" ? " select" : ""),
                    on: {
                      click: function($event) {
                        return _vm.selectView("list")
                      }
                    }
                  })
                ])
              ],
              1
            )
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.$store.state.tasks.length > 0
        ? _c(
            "div",
            { staticClass: "task-items myscroll lite-task-box" },
            [
              _vm.filterTasks.length == 0
                ? _c("div", { staticClass: "task-none" }, [
                    _c("img", {
                      attrs: {
                        src: require("../../assets/images/task-icon/no_task_bg.png"),
                        draggable: "false"
                      }
                    }),
                    _vm._v(" "),
                    _c("div", { staticClass: "task-none-title" }, [
                      _vm._v(_vm._s(_vm.$t("language.taskList.noTasks")))
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "task-none-desc" }, [
                      _vm._v(_vm._s(_vm.$t("language.taskList.noTasksTip")))
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "task-none-btn" }, [
                      _c("button", { on: { click: _vm.startCloudTransfer } }, [
                        _vm._v(
                          _vm._s(_vm.$t("language.taskList.startCloudTransfer"))
                        )
                      ]),
                      _vm._v(" "),
                      _c("button", { on: { click: _vm.startCloudSync } }, [
                        _vm._v(
                          _vm._s(_vm.$t("language.taskList.startCloudSync"))
                        )
                      ])
                    ])
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.activeView == "list" && _vm.filterTasks.length > 0
                ? _c(
                    "el-table",
                    {
                      staticClass: "task-list",
                      attrs: { data: _vm.filterTasks, height: "300px" },
                      on: { "selection-change": _vm.handleSelectionChange }
                    },
                    [
                      _c("el-table-column", {
                        attrs: {
                          type: "selection",
                          width: "42",
                          align: "center",
                          "header-align": "center"
                        }
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          label: _vm.$t("language.common.taskName"),
                          "show-overflow-tooltip": ""
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function(scope) {
                                return [
                                  _c("div", { staticClass: "row-task-name" }, [
                                    scope.row.type == "copy"
                                      ? _c("div", {
                                          staticClass: "cloudTransfer-black"
                                        })
                                      : _vm._e(),
                                    _vm._v(" "),
                                    scope.row.type == "tran"
                                      ? _c("div", {
                                          staticClass: "cloudTransfer-black"
                                        })
                                      : _vm._e(),
                                    _vm._v(" "),
                                    scope.row.type == "sync"
                                      ? _c("div", {
                                          staticClass: "cloudsync-black"
                                        })
                                      : _vm._e(),
                                    _vm._v(" "),
                                    scope.row.type == "backup"
                                      ? _c("div", {
                                          staticClass: "cloudbackup-black"
                                        })
                                      : _vm._e(),
                                    _vm._v(" "),
                                    scope.row.type == "restore"
                                      ? _c("div", {
                                          staticClass: "restoreTask-black"
                                        })
                                      : _vm._e(),
                                    _vm._v(" "),
                                    scope.row.type == "website"
                                      ? _c("div", {
                                          staticClass: "liteWebsite-black"
                                        })
                                      : _vm._e(),
                                    _vm._v(" "),
                                    scope.row.type == "clone"
                                      ? _c("div", {
                                          staticClass: "liteClone-black"
                                        })
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _c(
                                      "span",
                                      {
                                        staticClass: "row-task-name-text",
                                        attrs: { "data-type": scope.row.type },
                                        on: {
                                          click: function($event) {
                                            return _vm.renameTaskPopup(
                                              scope.row
                                            )
                                          }
                                        }
                                      },
                                      [_vm._v(_vm._s(scope.row.name))]
                                    )
                                  ])
                                ]
                              }
                            }
                          ],
                          null,
                          false,
                          2529158868
                        )
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          label: _vm.$t("language.common.from"),
                          "show-overflow-tooltip": ""
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function(scope) {
                                return [
                                  _c(
                                    "div",
                                    { staticClass: "row-task-from-to" },
                                    [
                                      _c("div", {
                                        class:
                                          "row-drive-icon drive-icon-" +
                                          _vm.getDrive(scope.row.fdid).type
                                      }),
                                      _vm._v(" "),
                                      _c(
                                        "el-tooltip",
                                        {
                                          attrs: {
                                            effect: "light",
                                            placement: "bottom",
                                            disabled:
                                              scope.row.param.from == null &&
                                              scope.row.param.froms == null
                                          }
                                        },
                                        [
                                          _c(
                                            "template",
                                            { slot: "content" },
                                            [
                                              scope.row.param.froms &&
                                              scope.row.param.froms.length > 0
                                                ? _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "froms_box myscroll"
                                                    },
                                                    _vm._l(
                                                      scope.row.param.froms,
                                                      function(from) {
                                                        return _c(
                                                          "el-breadcrumb",
                                                          {
                                                            key: from.node.id,
                                                            staticClass:
                                                              "folder-nav",
                                                            attrs: {
                                                              "separator-class":
                                                                "el-icon-arrow-right"
                                                            }
                                                          },
                                                          _vm._l(
                                                            _vm.getNodeArr(
                                                              from.node
                                                            ),
                                                            function(node) {
                                                              return _c(
                                                                "el-breadcrumb-item",
                                                                {
                                                                  key: node.id
                                                                },
                                                                [
                                                                  _c(
                                                                    "span",
                                                                    {
                                                                      class:
                                                                        "folder-nav-span " +
                                                                        (node.dir
                                                                          ? "folder"
                                                                          : "file"),
                                                                      attrs: {
                                                                        title:
                                                                          node.name
                                                                      },
                                                                      on: {
                                                                        click: function(
                                                                          $event
                                                                        ) {
                                                                          return _vm.openFolder(
                                                                            scope
                                                                              .row
                                                                              .fdid,
                                                                            node,
                                                                            null
                                                                          )
                                                                        }
                                                                      }
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        _vm._s(
                                                                          node.name
                                                                        )
                                                                      )
                                                                    ]
                                                                  )
                                                                ]
                                                              )
                                                            }
                                                          ),
                                                          1
                                                        )
                                                      }
                                                    ),
                                                    1
                                                  )
                                                : _c(
                                                    "el-breadcrumb",
                                                    {
                                                      staticClass: "folder-nav",
                                                      attrs: {
                                                        "separator-class":
                                                          "el-icon-arrow-right"
                                                      }
                                                    },
                                                    _vm._l(
                                                      _vm.getNodeArr(
                                                        scope.row.param.from
                                                      ),
                                                      function(node) {
                                                        return _c(
                                                          "el-breadcrumb-item",
                                                          { key: node.id },
                                                          [
                                                            _c(
                                                              "span",
                                                              {
                                                                class:
                                                                  "folder-nav-span " +
                                                                  (node.dir
                                                                    ? "folder"
                                                                    : "file"),
                                                                attrs: {
                                                                  title:
                                                                    node.name
                                                                },
                                                                on: {
                                                                  click: function(
                                                                    $event
                                                                  ) {
                                                                    return _vm.openFolder(
                                                                      scope.row
                                                                        .fdid,
                                                                      node,
                                                                      null
                                                                    )
                                                                  }
                                                                }
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    node.name
                                                                  )
                                                                )
                                                              ]
                                                            )
                                                          ]
                                                        )
                                                      }
                                                    ),
                                                    1
                                                  )
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              staticClass: "task-from-to",
                                              on: {
                                                click: function($event) {
                                                  return _vm.openFolder(
                                                    scope.row.fdid,
                                                    null,
                                                    null
                                                  )
                                                }
                                              }
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.getDrive(scope.row.fdid)
                                                    .name
                                                )
                                              )
                                            ]
                                          )
                                        ],
                                        2
                                      )
                                    ],
                                    1
                                  )
                                ]
                              }
                            }
                          ],
                          null,
                          false,
                          164533432
                        )
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          label: _vm.$t("language.common.to"),
                          "show-overflow-tooltip": ""
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function(scope) {
                                return [
                                  _c(
                                    "div",
                                    { staticClass: "row-task-from-to" },
                                    [
                                      _c("div", {
                                        class:
                                          "row-drive-icon drive-icon-" +
                                          _vm.getDrive(scope.row.tdid).type
                                      }),
                                      _vm._v(" "),
                                      _c(
                                        "el-tooltip",
                                        {
                                          attrs: {
                                            effect: "light",
                                            placement: "bottom",
                                            disabled: scope.row.param.to == null
                                          }
                                        },
                                        [
                                          _c(
                                            "template",
                                            { slot: "content" },
                                            [
                                              _c(
                                                "el-breadcrumb",
                                                {
                                                  staticClass: "folder-nav",
                                                  attrs: {
                                                    "separator-class":
                                                      "el-icon-arrow-right"
                                                  }
                                                },
                                                _vm._l(
                                                  _vm.getNodeArr(
                                                    scope.row.param.to
                                                  ),
                                                  function(node) {
                                                    return _c(
                                                      "el-breadcrumb-item",
                                                      { key: node.id },
                                                      [
                                                        _c(
                                                          "span",
                                                          {
                                                            class:
                                                              "folder-nav-span " +
                                                              (node.dir
                                                                ? "folder"
                                                                : "file"),
                                                            attrs: {
                                                              title: node.name
                                                            },
                                                            on: {
                                                              click: function(
                                                                $event
                                                              ) {
                                                                return _vm.openFolder(
                                                                  scope.row
                                                                    .tdid,
                                                                  node,
                                                                  null
                                                                )
                                                              }
                                                            }
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(node.name)
                                                            )
                                                          ]
                                                        )
                                                      ]
                                                    )
                                                  }
                                                ),
                                                1
                                              )
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              staticClass: "task-from-to",
                                              on: {
                                                click: function($event) {
                                                  return _vm.openFolder(
                                                    scope.row.tdid,
                                                    null,
                                                    null
                                                  )
                                                }
                                              }
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.getDrive(scope.row.tdid)
                                                    .name
                                                )
                                              )
                                            ]
                                          )
                                        ],
                                        2
                                      )
                                    ],
                                    1
                                  )
                                ]
                              }
                            }
                          ],
                          null,
                          false,
                          2645398605
                        )
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          label: _vm.$t(
                            "language.popup.cloudTransferPopup.schedule"
                          ),
                          "show-overflow-tooltip": ""
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function(scope) {
                                return [
                                  _c(
                                    "div",
                                    { staticClass: "task_cron row_task_cron" },
                                    [
                                      scope.row.param.options.cron ==
                                      "0 */5 * * * ?"
                                        ? _c(
                                            "span",
                                            {
                                              staticClass: "real-sync",
                                              on: {
                                                click: function($event) {
                                                  return _vm.taskOptionsPopup(
                                                    scope.row
                                                  )
                                                }
                                              }
                                            },
                                            [
                                              _c("i", {
                                                staticClass: "el-icon-loading"
                                              }),
                                              _vm._v(" "),
                                              _c("span", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t(
                                                      "language.cloudSync.realSyncing"
                                                    )
                                                  )
                                                )
                                              ])
                                            ]
                                          )
                                        : scope.row.type != "copy" &&
                                          scope.row.param.options.schedules
                                        ? _c("tabTaskSchdule", {
                                            attrs: {
                                              task: scope.row.param.options
                                            },
                                            on: {
                                              update: function($event) {
                                                return _vm.switchSchedule(
                                                  scope.row
                                                )
                                              },
                                              "open-popup": function($event) {
                                                return _vm.editSchedule(
                                                  scope.row
                                                )
                                              }
                                            }
                                          })
                                        : _vm._e()
                                    ],
                                    1
                                  )
                                ]
                              }
                            }
                          ],
                          null,
                          false,
                          1997381514
                        )
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          label: _vm.$t("language.common.status"),
                          "show-overflow-tooltip": "",
                          width: "180px"
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function(scope) {
                                return [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "row-task-status task-status",
                                      attrs: { "data-status": scope.row.status }
                                    },
                                    [
                                      scope.row.status == "create"
                                        ? _c("i", {
                                            staticClass: "el-icon-circle-plus"
                                          })
                                        : _vm._e(),
                                      _vm._v(" "),
                                      scope.row.status == "pending"
                                        ? _c("i", {
                                            staticClass: "el-icon-magic-stick"
                                          })
                                        : _vm._e(),
                                      _vm._v(" "),
                                      scope.row.status == "running"
                                        ? _c("i", {
                                            staticClass: "el-icon-loading"
                                          })
                                        : _vm._e(),
                                      _vm._v(" "),
                                      scope.row.status == "cancelled"
                                        ? _c("i", {
                                            staticClass: "el-icon-remove"
                                          })
                                        : _vm._e(),
                                      _vm._v(" "),
                                      scope.row.status == "completed"
                                        ? _c("i", {
                                            staticClass: "el-icon-success"
                                          })
                                        : _vm._e(),
                                      _vm._v(" "),
                                      scope.row.status == "failed"
                                        ? _c("i", {
                                            staticClass: "el-icon-error"
                                          })
                                        : _vm._e(),
                                      _vm._v(" "),
                                      scope.row.status == "warn"
                                        ? _c("i", {
                                            staticClass: "el-icon-warning"
                                          })
                                        : _vm._e(),
                                      _vm._v(" "),
                                      scope.row.status == "error"
                                        ? _c("i", {
                                            staticClass: "el-icon-s-release"
                                          })
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _c(
                                        "span",
                                        {
                                          staticClass: "task-status-text",
                                          on: {
                                            click: function($event) {
                                              return _vm.showTaskDetail(
                                                scope.row
                                              )
                                            }
                                          }
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "language.popup." +
                                                  scope.row.status +
                                                  "TaskStatus"
                                              )
                                            )
                                          )
                                        ]
                                      )
                                    ]
                                  )
                                ]
                              }
                            }
                          ],
                          null,
                          false,
                          2364782730
                        )
                      }),
                      _vm._v(" "),
                      _vm.activeName != "copy"
                        ? _c("el-table-column", {
                            attrs: {
                              label: _vm.$t("language.common.operate"),
                              width: "130px"
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function(scope) {
                                    return [
                                      scope.row.type != "copy"
                                        ? _c(
                                            "div",
                                            { staticClass: "row-task-options" },
                                            [
                                              !_vm.isRun(scope.row.status)
                                                ? _c("div", {
                                                    staticClass: "task_start",
                                                    on: {
                                                      click: function($event) {
                                                        return _vm.startTask(
                                                          scope.row.id
                                                        )
                                                      }
                                                    }
                                                  })
                                                : _vm._e(),
                                              _vm._v(" "),
                                              !_vm.isRun(scope.row.status)
                                                ? _c("div", {
                                                    staticClass: "task_more",
                                                    on: {
                                                      click: function($event) {
                                                        $event.stopPropagation()
                                                        return _vm.showTaskMoreMenu(
                                                          scope.row.id
                                                        )
                                                      }
                                                    }
                                                  })
                                                : _vm._e(),
                                              _vm._v(" "),
                                              _vm.isRun(scope.row.status)
                                                ? _c("div", {
                                                    staticClass: "task_stop",
                                                    on: {
                                                      click: function($event) {
                                                        return _vm.cancelTask(
                                                          scope.row.id
                                                        )
                                                      }
                                                    }
                                                  })
                                                : _vm._e(),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                {
                                                  directives: [
                                                    {
                                                      name: "show",
                                                      rawName: "v-show",
                                                      value:
                                                        !_vm.isRun(
                                                          scope.row.status
                                                        ) &&
                                                        _vm.taskMoreMenuId ==
                                                          scope.row.id,
                                                      expression:
                                                        "!isRun(scope.row.status) && taskMoreMenuId==scope.row.id"
                                                    }
                                                  ],
                                                  staticClass: "task_mores"
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass: "task_logs",
                                                      on: {
                                                        click: function(
                                                          $event
                                                        ) {
                                                          return _vm.showTaskDetail(
                                                            scope.row
                                                          )
                                                        }
                                                      }
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.$t(
                                                            "language.popup.taskListPopup.viewLogs"
                                                          )
                                                        )
                                                      )
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  scope.row.type == "backup" ||
                                                  scope.row.type == "website"
                                                    ? _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "task_restore",
                                                          on: {
                                                            click: function(
                                                              $event
                                                            ) {
                                                              return _vm.taskRestorePopup(
                                                                scope.row
                                                              )
                                                            }
                                                          }
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.$t(
                                                                "language.cloudBackup.restore"
                                                              )
                                                            )
                                                          )
                                                        ]
                                                      )
                                                    : _vm._e(),
                                                  _vm._v(" "),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "task_options",
                                                      on: {
                                                        click: function(
                                                          $event
                                                        ) {
                                                          return _vm.taskOptionsPopup(
                                                            scope.row
                                                          )
                                                        }
                                                      }
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.$t(
                                                            "language.common.options"
                                                          )
                                                        )
                                                      )
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "task_delete",
                                                      on: {
                                                        click: function(
                                                          $event
                                                        ) {
                                                          return _vm.deleteTaskPopup(
                                                            scope.row
                                                          )
                                                        }
                                                      }
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.$t(
                                                            "language.common.delete"
                                                          )
                                                        )
                                                      )
                                                    ]
                                                  )
                                                ]
                                              )
                                            ]
                                          )
                                        : _vm._e()
                                    ]
                                  }
                                }
                              ],
                              null,
                              false,
                              2381223096
                            )
                          })
                        : _vm._e()
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm._l(_vm.filterTasks, function(task) {
                return _vm.activeView == "box"
                  ? _c("div", { key: task.id, staticClass: "task-item" }, [
                      _c("div", { staticClass: "task-type" }, [
                        task.type == "copy"
                          ? _c("div", { staticClass: "cloudTransfer-black" })
                          : _vm._e(),
                        _vm._v(" "),
                        task.type == "tran"
                          ? _c("div", { staticClass: "cloudTransfer-black" })
                          : _vm._e(),
                        _vm._v(" "),
                        task.type == "sync"
                          ? _c("div", { staticClass: "cloudsync-black" })
                          : _vm._e(),
                        _vm._v(" "),
                        task.type == "backup"
                          ? _c("div", { staticClass: "cloudbackup-black" })
                          : _vm._e(),
                        _vm._v(" "),
                        task.type == "restore"
                          ? _c("div", { staticClass: "restoreTask-black" })
                          : _vm._e(),
                        _vm._v(" "),
                        task.type == "website"
                          ? _c("div", { staticClass: "liteWebsite-black" })
                          : _vm._e(),
                        _vm._v(" "),
                        task.type == "clone"
                          ? _c("div", { staticClass: "liteClone-black" })
                          : _vm._e(),
                        _vm._v(" "),
                        _c(
                          "span",
                          {
                            attrs: { "data-type": task.type, title: task.name },
                            on: {
                              click: function($event) {
                                return _vm.renameTaskPopup(task)
                              }
                            }
                          },
                          [_vm._v(_vm._s(task.name))]
                        )
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "task_cron" },
                        [
                          task.param.options.cron == "0 */5 * * * ?"
                            ? _c(
                                "span",
                                {
                                  staticClass: "real-sync",
                                  on: {
                                    click: function($event) {
                                      return _vm.taskOptionsPopup(task)
                                    }
                                  }
                                },
                                [
                                  _c("i", { staticClass: "el-icon-loading" }),
                                  _vm._v(" "),
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t("language.cloudSync.realSyncing")
                                      )
                                    )
                                  ])
                                ]
                              )
                            : task.type != "copy" &&
                              task.param.options.schedules
                            ? _c("tabTaskSchdule", {
                                attrs: { task: task.param.options },
                                on: {
                                  update: function($event) {
                                    return _vm.switchSchedule(task)
                                  },
                                  "open-popup": function($event) {
                                    return _vm.editSchedule(task)
                                  }
                                }
                              })
                            : _vm._e()
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticStyle: {
                            height: "80px",
                            "margin-top": "30px",
                            "padding-bottom": "60px",
                            "border-bottom": "1px solid #d3dcf0"
                          }
                        },
                        [
                          _c(
                            "el-row",
                            { attrs: { gutter: 20 } },
                            [
                              _c(
                                "el-col",
                                {
                                  staticStyle: {
                                    display: "flex",
                                    "justify-content": "right",
                                    "align-items": "center"
                                  },
                                  attrs: { span: 8 }
                                },
                                [
                                  _c(
                                    "div",
                                    { staticStyle: { "text-align": "center" } },
                                    [
                                      _c("div", {
                                        class:
                                          "drive-icon-" +
                                          _vm.getDrive(task.fdid).type,
                                        staticStyle: {
                                          width: "60px",
                                          height: "60px",
                                          margin: "0 auto"
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c(
                                        "el-tooltip",
                                        {
                                          attrs: {
                                            effect: "light",
                                            placement: "bottom",
                                            disabled:
                                              task.param.from == null &&
                                              task.param.froms == null
                                          }
                                        },
                                        [
                                          _c(
                                            "template",
                                            { slot: "content" },
                                            [
                                              task.param.froms &&
                                              task.param.froms.length > 0
                                                ? _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "froms_box myscroll"
                                                    },
                                                    _vm._l(
                                                      task.param.froms,
                                                      function(from) {
                                                        return _c(
                                                          "el-breadcrumb",
                                                          {
                                                            key: from.node.id,
                                                            staticClass:
                                                              "folder-nav",
                                                            attrs: {
                                                              "separator-class":
                                                                "el-icon-arrow-right"
                                                            }
                                                          },
                                                          _vm._l(
                                                            _vm.getNodeArr(
                                                              from.node
                                                            ),
                                                            function(node) {
                                                              return _c(
                                                                "el-breadcrumb-item",
                                                                {
                                                                  key: node.id
                                                                },
                                                                [
                                                                  _c(
                                                                    "span",
                                                                    {
                                                                      class:
                                                                        "folder-nav-span " +
                                                                        (node.dir
                                                                          ? "folder"
                                                                          : "file"),
                                                                      attrs: {
                                                                        title:
                                                                          node.name
                                                                      },
                                                                      on: {
                                                                        click: function(
                                                                          $event
                                                                        ) {
                                                                          return _vm.openFolder(
                                                                            task.fdid,
                                                                            node,
                                                                            null
                                                                          )
                                                                        }
                                                                      }
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        _vm._s(
                                                                          node.name
                                                                        )
                                                                      )
                                                                    ]
                                                                  )
                                                                ]
                                                              )
                                                            }
                                                          ),
                                                          1
                                                        )
                                                      }
                                                    ),
                                                    1
                                                  )
                                                : _c(
                                                    "el-breadcrumb",
                                                    {
                                                      staticClass: "folder-nav",
                                                      attrs: {
                                                        "separator-class":
                                                          "el-icon-arrow-right"
                                                      }
                                                    },
                                                    _vm._l(
                                                      _vm.getNodeArr(
                                                        task.param.from
                                                      ),
                                                      function(node) {
                                                        return _c(
                                                          "el-breadcrumb-item",
                                                          { key: node.id },
                                                          [
                                                            _c(
                                                              "span",
                                                              {
                                                                class:
                                                                  "folder-nav-span " +
                                                                  (node.dir
                                                                    ? "folder"
                                                                    : "file"),
                                                                attrs: {
                                                                  title:
                                                                    node.name
                                                                },
                                                                on: {
                                                                  click: function(
                                                                    $event
                                                                  ) {
                                                                    return _vm.openFolder(
                                                                      task.fdid,
                                                                      node,
                                                                      null
                                                                    )
                                                                  }
                                                                }
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    node.name
                                                                  )
                                                                )
                                                              ]
                                                            )
                                                          ]
                                                        )
                                                      }
                                                    ),
                                                    1
                                                  )
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              staticClass: "task-from-to",
                                              on: {
                                                click: function($event) {
                                                  return _vm.openFolder(
                                                    task.fdid,
                                                    null,
                                                    null
                                                  )
                                                }
                                              }
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.getDrive(task.fdid).name
                                                )
                                              )
                                            ]
                                          )
                                        ],
                                        2
                                      )
                                    ],
                                    1
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "el-col",
                                {
                                  staticStyle: {
                                    display: "flex",
                                    "justify-content": "center",
                                    "align-items": "center"
                                  },
                                  attrs: { span: 8 }
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "task-center-icon",
                                      attrs: { "data-type": task.type }
                                    },
                                    [
                                      task.type == "copy"
                                        ? _c("div", {
                                            staticClass: "double_arrow"
                                          })
                                        : _vm._e(),
                                      _vm._v(" "),
                                      task.type == "tran"
                                        ? _c("div", {
                                            staticClass: "double_arrow"
                                          })
                                        : _vm._e(),
                                      _vm._v(" "),
                                      task.type == "sync"
                                        ? _c("div", {
                                            class:
                                              task.param.options.syncMode ==
                                              "two"
                                                ? "sync_arrow"
                                                : "double_arrow"
                                          })
                                        : _vm._e(),
                                      _vm._v(" "),
                                      task.type == "backup"
                                        ? _c("div", {
                                            staticClass: "double_arrow"
                                          })
                                        : _vm._e(),
                                      _vm._v(" "),
                                      task.type == "restore"
                                        ? _c("div", {
                                            staticClass: "double_arrow"
                                          })
                                        : _vm._e(),
                                      _vm._v(" "),
                                      task.type == "website"
                                        ? _c("div", {
                                            staticClass: "double_arrow"
                                          })
                                        : _vm._e(),
                                      _vm._v(" "),
                                      task.type == "clone"
                                        ? _c("div", {
                                            staticClass: "double_arrow"
                                          })
                                        : _vm._e()
                                    ]
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "el-col",
                                {
                                  staticStyle: {
                                    display: "flex",
                                    "justify-content": "left",
                                    "align-items": "center"
                                  },
                                  attrs: { span: 8 }
                                },
                                [
                                  _c(
                                    "div",
                                    { staticStyle: { "text-align": "center" } },
                                    [
                                      _c("div", {
                                        class:
                                          "drive-icon-" +
                                          _vm.getDrive(task.tdid).type,
                                        staticStyle: {
                                          width: "60px",
                                          height: "60px",
                                          margin: "0 auto"
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c(
                                        "el-tooltip",
                                        {
                                          attrs: {
                                            effect: "light",
                                            placement: "bottom",
                                            disabled: task.param.to == null
                                          }
                                        },
                                        [
                                          _c(
                                            "template",
                                            { slot: "content" },
                                            [
                                              _c(
                                                "el-breadcrumb",
                                                {
                                                  staticClass: "folder-nav",
                                                  attrs: {
                                                    "separator-class":
                                                      "el-icon-arrow-right"
                                                  }
                                                },
                                                _vm._l(
                                                  _vm.getNodeArr(task.param.to),
                                                  function(node) {
                                                    return _c(
                                                      "el-breadcrumb-item",
                                                      { key: node.id },
                                                      [
                                                        _c(
                                                          "span",
                                                          {
                                                            class:
                                                              "folder-nav-span " +
                                                              (node.dir
                                                                ? "folder"
                                                                : "file"),
                                                            attrs: {
                                                              title: node.name
                                                            },
                                                            on: {
                                                              click: function(
                                                                $event
                                                              ) {
                                                                return _vm.openFolder(
                                                                  task.tdid,
                                                                  node,
                                                                  null
                                                                )
                                                              }
                                                            }
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(node.name)
                                                            )
                                                          ]
                                                        )
                                                      ]
                                                    )
                                                  }
                                                ),
                                                1
                                              )
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              staticClass: "task-from-to",
                                              on: {
                                                click: function($event) {
                                                  return _vm.openFolder(
                                                    task.tdid,
                                                    null,
                                                    null
                                                  )
                                                }
                                              }
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.getDrive(task.tdid).name
                                                )
                                              )
                                            ]
                                          )
                                        ],
                                        2
                                      )
                                    ],
                                    1
                                  )
                                ]
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticStyle: { "margin-top": "10px" } },
                        [
                          _c(
                            "el-row",
                            { attrs: { gutter: 10 } },
                            [
                              _c("el-col", { attrs: { span: 18 } }, [
                                _c(
                                  "div",
                                  {
                                    staticClass: "task-status",
                                    attrs: { "data-status": task.status }
                                  },
                                  [
                                    task.status == "create"
                                      ? _c("i", {
                                          staticClass: "el-icon-circle-plus"
                                        })
                                      : _vm._e(),
                                    _vm._v(" "),
                                    task.status == "pending"
                                      ? _c("i", {
                                          staticClass: "el-icon-magic-stick"
                                        })
                                      : _vm._e(),
                                    _vm._v(" "),
                                    task.status == "running"
                                      ? _c("i", {
                                          staticClass: "el-icon-loading"
                                        })
                                      : _vm._e(),
                                    _vm._v(" "),
                                    task.status == "cancelled"
                                      ? _c("i", {
                                          staticClass: "el-icon-remove"
                                        })
                                      : _vm._e(),
                                    _vm._v(" "),
                                    task.status == "completed"
                                      ? _c("i", {
                                          staticClass: "el-icon-success"
                                        })
                                      : _vm._e(),
                                    _vm._v(" "),
                                    task.status == "failed"
                                      ? _c("i", {
                                          staticClass: "el-icon-error"
                                        })
                                      : _vm._e(),
                                    _vm._v(" "),
                                    task.status == "warn"
                                      ? _c("i", {
                                          staticClass: "el-icon-warning"
                                        })
                                      : _vm._e(),
                                    _vm._v(" "),
                                    task.status == "error"
                                      ? _c("i", {
                                          staticClass: "el-icon-s-release"
                                        })
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _c(
                                      "span",
                                      {
                                        on: {
                                          click: function($event) {
                                            return _vm.showTaskDetail(task)
                                          }
                                        }
                                      },
                                      [
                                        _c(
                                          "span",
                                          { staticClass: "task-status-text" },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  "language.popup." +
                                                    task.status +
                                                    "TaskStatus"
                                                )
                                              )
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "span",
                                          { staticClass: "task-line-info" },
                                          [
                                            _vm._v(
                                              _vm._s(_vm.taskLineInfo(task))
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        !_vm.isVIP && task.status == "running"
                                          ? _c(
                                              "div",
                                              {
                                                staticClass: "speed-up-btn",
                                                on: {
                                                  click: function($event) {
                                                    $event.stopPropagation()
                                                    return _vm.showUpgrad()
                                                  }
                                                }
                                              },
                                              [
                                                _c("img", {
                                                  attrs: {
                                                    src: require("@/assets/images/vectorImg/speed_up.svg")
                                                  }
                                                }),
                                                _vm._v(" "),
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass: "speed-up-txt"
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t(
                                                          "language.taskList.speedUP"
                                                        )
                                                      )
                                                    )
                                                  ]
                                                )
                                              ]
                                            )
                                          : _vm._e()
                                      ]
                                    )
                                  ]
                                )
                              ]),
                              _vm._v(" "),
                              _c("el-col", { attrs: { span: 6 } }, [
                                task.type != "copy"
                                  ? _c("div", { staticClass: "task_action" }, [
                                      !_vm.isRun(task.status)
                                        ? _c("div", {
                                            staticClass: "task_start",
                                            on: {
                                              click: function($event) {
                                                return _vm.startTask(task.id)
                                              }
                                            }
                                          })
                                        : _vm._e(),
                                      _vm._v(" "),
                                      !_vm.isRun(task.status)
                                        ? _c("div", {
                                            staticClass: "task_more",
                                            on: {
                                              click: function($event) {
                                                $event.stopPropagation()
                                                return _vm.showTaskMoreMenu(
                                                  task.id
                                                )
                                              }
                                            }
                                          })
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.isRun(task.status)
                                        ? _c("div", {
                                            staticClass: "task_stop",
                                            on: {
                                              click: function($event) {
                                                return _vm.cancelTask(task.id)
                                              }
                                            }
                                          })
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          directives: [
                                            {
                                              name: "show",
                                              rawName: "v-show",
                                              value:
                                                !_vm.isRun(task.status) &&
                                                _vm.taskMoreMenuId == task.id,
                                              expression:
                                                "!isRun(task.status) && taskMoreMenuId==task.id"
                                            }
                                          ],
                                          staticClass: "task_mores"
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass: "task_logs",
                                              on: {
                                                click: function($event) {
                                                  return _vm.showTaskDetail(
                                                    task
                                                  )
                                                }
                                              }
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "language.popup.taskListPopup.viewLogs"
                                                  )
                                                )
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          task.type == "backup" ||
                                          task.type == "website"
                                            ? _c(
                                                "div",
                                                {
                                                  staticClass: "task_restore",
                                                  on: {
                                                    click: function($event) {
                                                      return _vm.taskRestorePopup(
                                                        task
                                                      )
                                                    }
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t(
                                                        "language.cloudBackup.restore"
                                                      )
                                                    )
                                                  )
                                                ]
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              staticClass: "task_options",
                                              on: {
                                                click: function($event) {
                                                  return _vm.taskOptionsPopup(
                                                    task
                                                  )
                                                }
                                              }
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "language.common.options"
                                                  )
                                                )
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              staticClass: "task_delete",
                                              on: {
                                                click: function($event) {
                                                  return _vm.deleteTaskPopup(
                                                    task
                                                  )
                                                }
                                              }
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "language.common.delete"
                                                  )
                                                )
                                              )
                                            ]
                                          )
                                        ]
                                      )
                                    ])
                                  : _vm._e()
                              ])
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ])
                  : _vm._e()
              })
            ],
            2
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.curTask && _vm.showCurTask
        ? _c("div", { staticClass: "lite_popup task_info" }, [
            _c("div", { staticClass: "lite_popup_box" }, [
              _c("div", { staticClass: "lite_popup_title" }, [
                _c("span", [
                  _vm._v(
                    _vm._s(_vm.$t("language.popup.viewLogsPopup.title")) +
                      " " +
                      _vm._s(_vm.curTask.name)
                  )
                ]),
                _vm._v(" "),
                _c("div", {
                  staticClass: "icon white-close dialog-close",
                  on: {
                    click: function($event) {
                      _vm.showCurTask = false
                    }
                  }
                })
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "lite_popup_content lite-task-datail" },
                [
                  _c(
                    "div",
                    {
                      staticClass: "task-status",
                      staticStyle: { "text-align": "center" },
                      attrs: { "data-status": _vm.curTask.status }
                    },
                    [
                      _vm.curTask.status == "create"
                        ? _c("i", { staticClass: "el-icon-circle-plus" })
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.curTask.status == "pending"
                        ? _c("i", { staticClass: "el-icon-magic-stick" })
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.curTask.status == "running"
                        ? _c("i", { staticClass: "el-icon-loading" })
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.curTask.status == "cancelled"
                        ? _c("i", { staticClass: "el-icon-remove" })
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.curTask.status == "completed"
                        ? _c("i", { staticClass: "el-icon-success" })
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.curTask.status == "failed"
                        ? _c("i", { staticClass: "el-icon-error" })
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.curTask.status == "warn"
                        ? _c("i", { staticClass: "el-icon-warning" })
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.curTask.status == "error"
                        ? _c("i", { staticClass: "el-icon-s-release" })
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "el-tooltip",
                        { attrs: { effect: "light", placement: "bottom" } },
                        [
                          _c("template", { slot: "content" }, [
                            _c("div", { staticClass: "cur_task_msg" }, [
                              _c("span", [
                                _c("b", [_vm._v("Task Msg:")]),
                                _vm._v(" " + _vm._s(_vm.curTask.msg))
                              ])
                            ]),
                            _vm._v(" "),
                            _vm.curTask.result.curMsg
                              ? _c("div", { staticClass: "cur_task_msg" }, [
                                  _c("span", [
                                    _c("b", [_vm._v("Cur Msg:")]),
                                    _vm._v(
                                      " " + _vm._s(_vm.curTask.result.curMsg)
                                    )
                                  ])
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.curTask.result.curNode
                              ? _c("div", { staticClass: "cur_task_msg" }, [
                                  _c("div", [
                                    _c("span", [
                                      _c("b", [_vm._v("Cur Node:")]),
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.getNodePath(
                                              _vm.curTask.result.curNode
                                            )
                                          )
                                      )
                                    ])
                                  ]),
                                  _vm._v(" "),
                                  _c("div", [
                                    _c("span", [
                                      _c("b", [_vm._v("Cur Node Msg:")]),
                                      _vm._v(
                                        " " +
                                          _vm._s(_vm.curTask.result.curNode.msg)
                                      )
                                    ])
                                  ])
                                ])
                              : _vm._e()
                          ]),
                          _vm._v(" "),
                          _c("span", { staticClass: "task-status-text" }, [
                            _vm._v(
                              _vm._s(
                                _vm.$t(
                                  "language.popup." +
                                    _vm.curTask.status +
                                    "TaskStatus"
                                )
                              ) +
                                " " +
                                _vm._s(_vm.taskLineInfo(_vm.curTask))
                            )
                          ])
                        ],
                        2
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.curTask.type == "sync"
                    ? _c(
                        "div",
                        {
                          staticStyle: {
                            margin: "30px 0px",
                            "text-align": "center"
                          }
                        },
                        [
                          _vm.hasErrors(_vm.curTask)
                            ? _c(
                                "div",
                                {
                                  staticStyle: {
                                    "text-align": "center",
                                    display: "inline-block",
                                    margin: "0 10px"
                                  }
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticStyle: {
                                        "margin-bottom": "5px",
                                        color: "#f65d58"
                                      }
                                    },
                                    [
                                      _c("b", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.curTask.result.countWarn +
                                              _vm.curTask.result.countError
                                          )
                                        )
                                      ])
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "span",
                                    { staticStyle: { color: "#f65d58" } },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "language.popup.viewLogsPopup.errorNum"
                                          )
                                        )
                                      )
                                    ]
                                  )
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.hasErrors(_vm.curTask)
                            ? _c("div", {
                                staticClass: "size_line",
                                staticStyle: {
                                  "margin-left": "35px",
                                  "margin-right": "35px",
                                  display: "inline-block"
                                }
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticStyle: {
                                "text-align": "center",
                                color: "#606266",
                                display: "inline-block",
                                margin: "0 10px"
                              }
                            },
                            [
                              _c(
                                "div",
                                { staticStyle: { "margin-bottom": "5px" } },
                                [
                                  _c("b", [
                                    _vm._v(_vm._s(_vm.curTask.result.countAdd))
                                  ])
                                ]
                              ),
                              _vm._v(" "),
                              _c("span", [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t(
                                      "language.popup.viewLogsPopup.addNum"
                                    )
                                  )
                                )
                              ])
                            ]
                          ),
                          _vm._v(" "),
                          _c("div", {
                            staticClass: "size_line",
                            staticStyle: {
                              "margin-left": "35px",
                              "margin-right": "35px",
                              display: "inline-block"
                            }
                          }),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticStyle: {
                                "text-align": "center",
                                color: "#606266",
                                display: "inline-block",
                                margin: "0 10px"
                              }
                            },
                            [
                              _c(
                                "div",
                                { staticStyle: { "margin-bottom": "5px" } },
                                [
                                  _c("b", [
                                    _vm._v(
                                      _vm._s(_vm.curTask.result.countUpdate)
                                    )
                                  ])
                                ]
                              ),
                              _vm._v(" "),
                              _c("span", [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t(
                                      "language.popup.viewLogsPopup.updateNum"
                                    )
                                  )
                                )
                              ])
                            ]
                          ),
                          _vm._v(" "),
                          _c("div", {
                            staticClass: "size_line",
                            staticStyle: {
                              "margin-left": "35px",
                              "margin-right": "35px",
                              display: "inline-block"
                            }
                          }),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticStyle: {
                                "text-align": "center",
                                color: "#606266",
                                display: "inline-block",
                                margin: "0 10px"
                              }
                            },
                            [
                              _c(
                                "div",
                                { staticStyle: { "margin-bottom": "5px" } },
                                [
                                  _c("b", [
                                    _vm._v(
                                      _vm._s(_vm.curTask.result.countDelete)
                                    )
                                  ])
                                ]
                              ),
                              _vm._v(" "),
                              _c("span", [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t(
                                      "language.popup.viewLogsPopup.deleteNum"
                                    )
                                  )
                                )
                              ])
                            ]
                          ),
                          _vm._v(" "),
                          _c("div", {
                            staticClass: "size_line",
                            staticStyle: {
                              "margin-left": "35px",
                              "margin-right": "35px",
                              display: "inline-block"
                            }
                          }),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticStyle: {
                                "text-align": "center",
                                color: "#606266",
                                display: "inline-block",
                                margin: "0 10px"
                              }
                            },
                            [
                              _c(
                                "div",
                                { staticStyle: { "margin-bottom": "5px" } },
                                [
                                  _c("b", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.formatBytes(
                                          _vm.curTask.result.sizeCur
                                        )
                                      )
                                    )
                                  ])
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "el-tooltip",
                                {
                                  attrs: {
                                    effect: "light",
                                    placement: "bottom"
                                  }
                                },
                                [
                                  _c("template", { slot: "content" }, [
                                    _c("div", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.avgSpeed(
                                            _vm.curTask.result.startTime,
                                            _vm.curTask.result.endTime,
                                            _vm.curTask.result.sizeCur
                                          )
                                        )
                                      )
                                    ])
                                  ]),
                                  _vm._v(" "),
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(
                                          "language.popup.viewLogsPopup.syncSize"
                                        )
                                      )
                                    )
                                  ])
                                ],
                                2
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("div", {
                            staticClass: "size_line",
                            staticStyle: {
                              "margin-left": "35px",
                              "margin-right": "35px",
                              display: "inline-block"
                            }
                          }),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticStyle: {
                                "text-align": "center",
                                color: "#606266",
                                display: "inline-block",
                                margin: "0 10px"
                              }
                            },
                            [
                              _c(
                                "div",
                                { staticStyle: { "margin-bottom": "5px" } },
                                [
                                  _c("b", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.formatTime(
                                          _vm.curTask.result.endTime -
                                            _vm.curTask.result.startTime
                                        )
                                      )
                                    )
                                  ])
                                ]
                              ),
                              _vm._v(" "),
                              _c("span", [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t(
                                      "language.popup.viewLogsPopup.syncTime"
                                    )
                                  )
                                )
                              ])
                            ]
                          )
                        ]
                      )
                    : _c(
                        "el-row",
                        {
                          staticStyle: { margin: "30px 0px" },
                          attrs: { gutter: 20 }
                        },
                        [
                          _c(
                            "el-col",
                            {
                              staticStyle: {
                                display: "flex",
                                "justify-content": "right",
                                "align-items": "center"
                              },
                              attrs: {
                                span: _vm.hasErrors(_vm.curTask) ? 12 : 10
                              }
                            },
                            [
                              _vm.hasErrors(_vm.curTask)
                                ? _c(
                                    "div",
                                    { staticStyle: { "text-align": "center" } },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticStyle: {
                                            "margin-bottom": "5px",
                                            color: "#f65d58"
                                          }
                                        },
                                        [
                                          _c("b", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.curTask.result.countWarn +
                                                  _vm.curTask.result.countError
                                              )
                                            )
                                          ])
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "span",
                                        { staticStyle: { color: "#f65d58" } },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "language.popup.viewLogsPopup.errorNum"
                                              )
                                            )
                                          )
                                        ]
                                      )
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.hasErrors(_vm.curTask)
                                ? _c("div", {
                                    staticClass: "size_line",
                                    staticStyle: {
                                      "margin-left": "35px",
                                      "margin-right": "35px"
                                    }
                                  })
                                : _vm._e(),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticStyle: {
                                    "text-align": "center",
                                    color: "#606266"
                                  }
                                },
                                [
                                  _c(
                                    "div",
                                    { staticStyle: { "margin-bottom": "5px" } },
                                    [
                                      _c("b", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.curTask.result.countSuccess
                                          )
                                        )
                                      ])
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "el-tooltip",
                                    {
                                      attrs: {
                                        effect: "light",
                                        placement: "bottom"
                                      }
                                    },
                                    [
                                      _c("template", { slot: "content" }, [
                                        _c("span", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.countTitle(_vm.curTask.result)
                                            )
                                          )
                                        ])
                                      ]),
                                      _vm._v(" "),
                                      _c("span", [
                                        _vm.curTask.type == "website"
                                          ? _c("span", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "language.popup.viewLogsPopup.backupNum"
                                                  )
                                                )
                                              )
                                            ])
                                          : _vm.curTask.type == "backup"
                                          ? _c("span", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "language.popup.viewLogsPopup.backupNum"
                                                  )
                                                )
                                              )
                                            ])
                                          : _vm.curTask.type == "restore"
                                          ? _c("span", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "language.popup.viewLogsPopup.restoreNum"
                                                  )
                                                )
                                              )
                                            ])
                                          : _vm.curTask.type == "clone"
                                          ? _c("span", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "language.popup.viewLogsPopup.cloneNum"
                                                  )
                                                )
                                              )
                                            ])
                                          : _c("span", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "language.popup.viewLogsPopup.tranNum"
                                                  )
                                                )
                                              )
                                            ])
                                      ])
                                    ],
                                    2
                                  )
                                ],
                                1
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "el-col",
                            {
                              staticStyle: {
                                display: "flex",
                                "justify-content": "center",
                                "align-items": "center"
                              },
                              attrs: { span: 4 }
                            },
                            [
                              _c("div", {
                                staticClass: "size_line",
                                staticStyle: { "margin-right": "35px" }
                              }),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticStyle: {
                                    "text-align": "center",
                                    color: "#606266"
                                  }
                                },
                                [
                                  _c(
                                    "div",
                                    { staticStyle: { "margin-bottom": "5px" } },
                                    [
                                      _c("b", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.formatBytes(
                                              _vm.curTask.result.sizeCur
                                            )
                                          )
                                        )
                                      ])
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "el-tooltip",
                                    {
                                      attrs: {
                                        effect: "light",
                                        placement: "bottom"
                                      }
                                    },
                                    [
                                      _c("template", { slot: "content" }, [
                                        _c("div", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.avgSpeed(
                                                _vm.curTask.result.startTime,
                                                _vm.curTask.result.endTime,
                                                _vm.curTask.result.sizeCur
                                              )
                                            )
                                          )
                                        ])
                                      ]),
                                      _vm._v(" "),
                                      _c("span", [
                                        _vm.curTask.type == "website"
                                          ? _c("span", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "language.popup.viewLogsPopup.backupSize"
                                                  )
                                                )
                                              )
                                            ])
                                          : _vm.curTask.type == "backup"
                                          ? _c("span", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "language.popup.viewLogsPopup.backupSize"
                                                  )
                                                )
                                              )
                                            ])
                                          : _vm.curTask.type == "restore"
                                          ? _c("span", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "language.popup.viewLogsPopup.restoreSize"
                                                  )
                                                )
                                              )
                                            ])
                                          : _vm.curTask.type == "clone"
                                          ? _c("span", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "language.popup.viewLogsPopup.cloneSize"
                                                  )
                                                )
                                              )
                                            ])
                                          : _c("span", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "language.popup.viewLogsPopup.tranSize"
                                                  )
                                                )
                                              )
                                            ])
                                      ])
                                    ],
                                    2
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c("div", {
                                staticClass: "size_line",
                                staticStyle: { "margin-left": "35px" }
                              })
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "el-col",
                            {
                              staticStyle: {
                                display: "flex",
                                "justify-content": "left",
                                "align-items": "center"
                              },
                              attrs: {
                                span: _vm.hasErrors(_vm.curTask) ? 8 : 10
                              }
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticStyle: {
                                    "text-align": "center",
                                    color: "#606266"
                                  }
                                },
                                [
                                  _c(
                                    "div",
                                    { staticStyle: { "margin-bottom": "5px" } },
                                    [
                                      _c("b", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.formatTime(
                                              _vm.curTask.result.endTime -
                                                _vm.curTask.result.startTime
                                            )
                                          )
                                        )
                                      ])
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("span", [
                                    _vm.curTask.type == "website"
                                      ? _c("span", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "language.popup.viewLogsPopup.backupTime"
                                              )
                                            )
                                          )
                                        ])
                                      : _vm.curTask.type == "backup"
                                      ? _c("span", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "language.popup.viewLogsPopup.backupTime"
                                              )
                                            )
                                          )
                                        ])
                                      : _vm.curTask.type == "restore"
                                      ? _c("span", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "language.popup.viewLogsPopup.restoreTime"
                                              )
                                            )
                                          )
                                        ])
                                      : _vm.curTask.type == "clone"
                                      ? _c("span", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "language.popup.viewLogsPopup.cloneTime"
                                              )
                                            )
                                          )
                                        ])
                                      : _c("span", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "language.popup.viewLogsPopup.tranTime"
                                              )
                                            )
                                          )
                                        ])
                                  ])
                                ]
                              )
                            ]
                          )
                        ],
                        1
                      ),
                  _vm._v(" "),
                  ["create", "pending", "completed"].includes(
                    _vm.curTask.status
                  ) ||
                  (_vm.curTask.status == "cancelled" && !_vm.curTask.errors)
                    ? _c("div", { staticClass: "lite_task_detail" }, [
                        _c("div", { staticClass: "lite_task_detail_title" }, [
                          _c("b", [
                            _vm._v(
                              _vm._s(_vm.$t("language.popup.viewLogsPopup.to"))
                            )
                          ]),
                          _vm._v(" "),
                          _c(
                            "span",
                            { staticClass: "lite_task_detail_to_path" },
                            [
                              _c(
                                "span",
                                {
                                  staticClass: "lite_task_detail_node",
                                  on: {
                                    click: function($event) {
                                      return _vm.openFolder(
                                        _vm.curTask.tdid,
                                        null,
                                        null
                                      )
                                    }
                                  }
                                },
                                [
                                  _vm._v(
                                    _vm._s(_vm.getDrive(_vm.curTask.tdid).name)
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _vm._l(
                                _vm.getNodeArr(_vm.curTask.param.to),
                                function(node) {
                                  return _c("span", { key: node.id }, [
                                    _c("span", [
                                      _vm._v("/"),
                                      _c(
                                        "span",
                                        {
                                          class:
                                            "lite_task_detail_node" +
                                            (node.dir
                                              ? " node-folder"
                                              : "node-file"),
                                          on: {
                                            click: function($event) {
                                              return _vm.openFolder(
                                                _vm.curTask.tdid,
                                                node,
                                                null
                                              )
                                            }
                                          }
                                        },
                                        [_vm._v(_vm._s(node.name))]
                                      )
                                    ])
                                  ])
                                }
                              )
                            ],
                            2
                          ),
                          _vm._v(" "),
                          _c(
                            "span",
                            { staticClass: "lite_task_detail_title_time" },
                            [
                              _c("span", [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t(
                                      "language.popup.viewLogsPopup.executeTime"
                                    )
                                  )
                                )
                              ]),
                              _vm._v(" "),
                              _c("span", [
                                _vm._v(
                                  _vm._s(
                                    _vm.formatDate(_vm.curTask.result.startTime)
                                  ) +
                                    " - " +
                                    _vm._s(
                                      _vm.formatDate(_vm.curTask.result.endTime)
                                    )
                                )
                              ])
                            ]
                          )
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "lite_task_detail_title_from" },
                          [
                            _c("div", { staticClass: "lite_sub_title" }, [
                              _vm._v(_vm._s(_vm.$t("language.common.from")))
                            ]),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass: "lite_sub_title lite_sub_title_big"
                              },
                              [
                                _vm._v(
                                  _vm._s(_vm.$t("language.common.fileProcess"))
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "lite_sub_title lite_sub_title_small"
                              },
                              [
                                _vm._v(
                                  _vm._s(_vm.$t("language.common.dataProcess"))
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "lite_sub_title lite_sub_title_small"
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t(
                                      "language.popup.viewLogsPopup.tranTime"
                                    )
                                  )
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "lite_sub_title lite_sub_title_small"
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t(
                                      "language.popup.viewLogsPopup.executeResult"
                                    )
                                  )
                                )
                              ]
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "lite_task_detail_from" }, [
                          _c(
                            "div",
                            {
                              staticClass:
                                "lite_sub_title lite_task_detail_fromn_path"
                            },
                            [
                              _vm.curTask.param.froms &&
                              _vm.curTask.param.froms.length > 0
                                ? _c(
                                    "div",
                                    [
                                      _c(
                                        "el-tooltip",
                                        {
                                          attrs: {
                                            effect: "light",
                                            placement: "bottom-start"
                                          }
                                        },
                                        [
                                          _c("template", { slot: "content" }, [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "froms_box myscroll"
                                              },
                                              _vm._l(
                                                _vm.curTask.param.froms,
                                                function(from) {
                                                  return _c(
                                                    "div",
                                                    { key: from.node.id },
                                                    _vm._l(
                                                      _vm.getNodeArr(from.node),
                                                      function(node) {
                                                        return _c(
                                                          "span",
                                                          { key: node.id },
                                                          [
                                                            _c("span", [
                                                              _vm._v("/"),
                                                              _c(
                                                                "span",
                                                                {
                                                                  class:
                                                                    "lite_task_detail_node" +
                                                                    (node.dir
                                                                      ? " node-folder"
                                                                      : "node-file"),
                                                                  attrs: {
                                                                    title:
                                                                      node.name
                                                                  },
                                                                  on: {
                                                                    click: function(
                                                                      $event
                                                                    ) {
                                                                      return _vm.openFolder(
                                                                        _vm
                                                                          .curTask
                                                                          .fdid,
                                                                        node,
                                                                        null
                                                                      )
                                                                    }
                                                                  }
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      node.name
                                                                    )
                                                                  )
                                                                ]
                                                              )
                                                            ])
                                                          ]
                                                        )
                                                      }
                                                    ),
                                                    0
                                                  )
                                                }
                                              ),
                                              0
                                            )
                                          ]),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              staticStyle: {
                                                display: "inline-block"
                                              }
                                            },
                                            [
                                              _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "lite_task_detail_node",
                                                  on: {
                                                    click: function($event) {
                                                      return _vm.openFolder(
                                                        _vm.curTask.fdid,
                                                        null,
                                                        null
                                                      )
                                                    }
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.getDrive(
                                                        _vm.curTask.fdid
                                                      ).name
                                                    )
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _vm._l(
                                                _vm.getNodeArr(
                                                  _vm.curTask.param.from
                                                ),
                                                function(node) {
                                                  return _c(
                                                    "span",
                                                    { key: node.id },
                                                    [
                                                      _c("span", [
                                                        _vm._v("/"),
                                                        _c(
                                                          "span",
                                                          {
                                                            class:
                                                              "lite_task_detail_node" +
                                                              (node.dir
                                                                ? " node-folder"
                                                                : "node-file"),
                                                            attrs: {
                                                              title: node.name
                                                            },
                                                            on: {
                                                              click: function(
                                                                $event
                                                              ) {
                                                                return _vm.openFolder(
                                                                  _vm.curTask
                                                                    .fdid,
                                                                  node,
                                                                  null
                                                                )
                                                              }
                                                            }
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(node.name)
                                                            )
                                                          ]
                                                        )
                                                      ])
                                                    ]
                                                  )
                                                }
                                              )
                                            ],
                                            2
                                          )
                                        ],
                                        2
                                      )
                                    ],
                                    1
                                  )
                                : _c(
                                    "div",
                                    [
                                      _c(
                                        "span",
                                        {
                                          staticClass: "lite_task_detail_node",
                                          on: {
                                            click: function($event) {
                                              return _vm.openFolder(
                                                _vm.curTask.fdid,
                                                null,
                                                null
                                              )
                                            }
                                          }
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.getDrive(_vm.curTask.fdid)
                                                .name
                                            )
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _vm._l(
                                        _vm.getNodeArr(_vm.curTask.param.from),
                                        function(node) {
                                          return _c("span", { key: node.id }, [
                                            _c("span", [
                                              _vm._v("/"),
                                              _c(
                                                "span",
                                                {
                                                  class:
                                                    "lite_task_detail_node" +
                                                    (node.dir
                                                      ? " node-folder"
                                                      : "node-file"),
                                                  attrs: { title: node.name },
                                                  on: {
                                                    click: function($event) {
                                                      return _vm.openFolder(
                                                        _vm.curTask.fdid,
                                                        node,
                                                        null
                                                      )
                                                    }
                                                  }
                                                },
                                                [_vm._v(_vm._s(node.name))]
                                              )
                                            ])
                                          ])
                                        }
                                      )
                                    ],
                                    2
                                  )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "lite_sub_title lite_sub_title_big"
                            },
                            [
                              _vm.curTask.type == "sync"
                                ? _c(
                                    "span",
                                    [
                                      _c(
                                        "el-tooltip",
                                        {
                                          attrs: {
                                            effect: "light",
                                            placement: "bottom"
                                          }
                                        },
                                        [
                                          _c("template", { slot: "content" }, [
                                            _c("span", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.countTitle(
                                                    _vm.curTask.result
                                                  )
                                                )
                                              )
                                            ])
                                          ]),
                                          _vm._v(" "),
                                          _c("span", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  "language.popup.viewLogsPopup.add"
                                                ) +
                                                  _vm.curTask.result.countAdd +
                                                  " " +
                                                  _vm.$t(
                                                    "language.popup.viewLogsPopup.update"
                                                  ) +
                                                  _vm.curTask.result
                                                    .countUpdate +
                                                  " " +
                                                  _vm.$t(
                                                    "language.popup.viewLogsPopup.delete"
                                                  ) +
                                                  _vm.curTask.result.countDelete
                                              )
                                            )
                                          ])
                                        ],
                                        2
                                      )
                                    ],
                                    1
                                  )
                                : _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.curTask.result.countSuccess +
                                          " / " +
                                          _vm.curTask.result.countSum
                                      )
                                    )
                                  ])
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "lite_sub_title lite_sub_title_small"
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.formatBytes(_vm.curTask.result.sizeCur) +
                                    " / " +
                                    _vm.formatBytes(_vm.curTask.result.sizeSum)
                                )
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "lite_sub_title lite_sub_title_small"
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.formatTime(
                                    _vm.curTask.result.endTime -
                                      _vm.curTask.result.startTime
                                  )
                                )
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "lite_sub_title lite_sub_title_small"
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$t(
                                    "language.popup." +
                                      _vm.curTask.status +
                                      "TaskStatus"
                                  )
                                )
                              )
                            ]
                          )
                        ])
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.curTask.status == "running"
                    ? _c(
                        "el-table",
                        {
                          staticClass: "lite-table-running",
                          attrs: {
                            data: _vm.curTask.result.runningFiles,
                            border: "",
                            "highlight-current-row": "",
                            height: "428px",
                            "empty-text": " "
                          }
                        },
                        [
                          _c("el-table-column", {
                            attrs: { type: "index", width: "50" }
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              label: _vm.$t("language.common.transferFiles"),
                              "show-overflow-tooltip": "",
                              width: "860px"
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function(scope) {
                                    return [
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(_vm.getNodePath(scope.row))
                                        )
                                      ])
                                    ]
                                  }
                                }
                              ],
                              null,
                              false,
                              1525508786
                            )
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              label: _vm.$t("language.common.status"),
                              "show-overflow-tooltip": ""
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function(scope) {
                                    return [
                                      !_vm.isVIP && scope.row.msg == "lock"
                                        ? _c("img", {
                                            staticClass: "thread_lock",
                                            attrs: {
                                              src: require("../../assets/images/task-icon/progress_lock.svg"),
                                              draggable: "false"
                                            },
                                            on: {
                                              click: function($event) {
                                                return _vm.showUpgrad()
                                              }
                                            }
                                          })
                                        : _c("span", [
                                            _vm._v(_vm._s(scope.row.msg))
                                          ])
                                    ]
                                  }
                                }
                              ],
                              null,
                              false,
                              1319278414
                            )
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c("div", {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.loadingErrorFiles,
                        expression: "loadingErrorFiles"
                      }
                    ],
                    staticClass: "lite-error-loading"
                  }),
                  _vm._v(" "),
                  _vm.curTask.errors && _vm.isDone(_vm.curTask.status)
                    ? _c(
                        "el-table",
                        {
                          staticClass: "lite-table-error",
                          attrs: {
                            data: _vm.curTask.errors,
                            border: "",
                            "highlight-current-row": "",
                            height: "428px",
                            "empty-text": " "
                          }
                        },
                        [
                          _c("el-table-column", {
                            attrs: { type: "index", width: "50" }
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              label: _vm.$t("language.common.transferFiles"),
                              "show-overflow-tooltip": "",
                              width: "400px"
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function(scope) {
                                    return [
                                      scope.row.dir
                                        ? _c("i", {
                                            staticClass: "el-icon-folder"
                                          })
                                        : _c("i", {
                                            staticClass: "el-icon-document"
                                          }),
                                      _vm._v(" "),
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(_vm.getNodePath(scope.row))
                                        )
                                      ])
                                    ]
                                  }
                                }
                              ],
                              null,
                              false,
                              132183544
                            )
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              label: _vm.$t("language.common.size"),
                              width: "100px"
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function(scope) {
                                    return [
                                      _vm._v(
                                        "\n                            " +
                                          _vm._s(
                                            _vm.formatBytes(scope.row.size)
                                          ) +
                                          "\n                        "
                                      )
                                    ]
                                  }
                                }
                              ],
                              null,
                              false,
                              1960918851
                            )
                          }),
                          _vm._v(" "),
                          false
                            ? _c("el-table-column", {
                                attrs: {
                                  label: _vm.$t("language.popup.warning"),
                                  width: "120px"
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function(scope) {
                                        return [
                                          _vm._v(
                                            "\n                            " +
                                              _vm._s(scope.row.warn) +
                                              "\n                        "
                                          )
                                        ]
                                      }
                                    }
                                  ],
                                  null,
                                  false,
                                  632292887
                                )
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              label: _vm.$t("language.popup.detailed"),
                              "show-overflow-tooltip": ""
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function(scope) {
                                    return [
                                      _vm._v(
                                        "\n                            " +
                                          _vm._s(scope.row.msg) +
                                          "\n                        "
                                      )
                                    ]
                                  }
                                }
                              ],
                              null,
                              false,
                              2448256612
                            )
                          }),
                          _vm._v(" "),
                          false
                            ? _c("el-table-column", {
                                attrs: {
                                  label: _vm.$t("language.popup.logs"),
                                  width: "100px"
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function(scope) {
                                        return [
                                          _c(
                                            "span",
                                            {
                                              staticClass: "show-trace",
                                              on: {
                                                click: function($event) {
                                                  _vm.traceInfo =
                                                    scope.row.trace
                                                }
                                              }
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "language.imageSaver.view"
                                                  )
                                                )
                                              )
                                            ]
                                          )
                                        ]
                                      }
                                    }
                                  ],
                                  null,
                                  false,
                                  1144111854
                                )
                              })
                            : _vm._e()
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.traceInfo
                    ? _c("pre", { staticClass: "trace-info" }, [
                        _vm._v(_vm._s(_vm.traceInfo))
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.traceInfo
                    ? _c(
                        "el-button",
                        {
                          staticClass: "trace-close",
                          attrs: { size: "small", circle: "" },
                          on: {
                            click: function($event) {
                              _vm.traceInfo = null
                            }
                          }
                        },
                        [_c("i", { staticClass: "el-icon-close" })]
                      )
                    : _vm._e()
                ],
                1
              )
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("liteInput", {
        ref: "inputPopup",
        attrs: { data: _vm.input_popup_data },
        on: { ok: _vm.inputPopupOK }
      }),
      _vm._v(" "),
      _c("liteConfirm", {
        ref: "confirmPopup",
        attrs: { data: _vm.confirm_popup_data },
        on: { ok: _vm.confirmPopupOK }
      }),
      _vm._v(" "),
      _c("liteOptions", {
        ref: "taskOptions",
        attrs: { data: _vm.curTaskOptions },
        on: { ok: _vm.okOptions }
      }),
      _vm._v(" "),
      _c("liteRestore", {
        ref: "taskRestore",
        attrs: { data: _vm.curTaskRetore },
        on: { ok: _vm.okRestore }
      }),
      _vm._v(" "),
      _c("transferScheduleDialog", {
        ref: "transferScheduleDialog",
        attrs: { schedules: _vm.pSchedules }
      }),
      _vm._v(" "),
      _c("upgradeNewDialog", { ref: "upgradeNewDialog" })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-316d959c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-316d959c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/workspace/lite_task.vue
// module id = null
// module chunks = 